<script setup lang="ts">
import { toastVariants } from '@satch-ui/primitives/toast/variants'

import { ToastLayout } from '@fond-of/fondof-ui'
import { CircleExclamationIcon, CloseCircleIcon } from '@fond-of/satch-icons'

const props = defineProps<{
  icon?: any
}>()
</script>

<template>
  <ToastLayout :class="toastVariants({ variant: 'info' })">
    <template #icon>
      <component
        :is="props.icon || CircleExclamationIcon"
        class="text-primary size-6"
      />
    </template>

    <template #default="slotProps">
      <slot v-bind="slotProps" />
    </template>

    <template #close>
      <CloseCircleIcon class="size-6 text-black" />
    </template>
  </ToastLayout>
</template>
